let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ygkQh")).then(() => parcelRequire('k6ygv'));